import api from '../utils/axios';

export const getCompanyDashboardStats = async (scope = 'company') => {
  try {
    const response = await api.get('/dashboard/company', { params: { scope } });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
